import React from 'react'
import Slider from "../Slider";

const PlanSlider = () => {
  return (
    <div className="bg-[#F0F0F0] lg:pt-36 pb-1">
      <div className='mt-28'>
        <Slider/>
      </div>
    </div>
  )
}

export default PlanSlider